import { ConsoleScreen, ScreenChar } from '../console/console-screen';
import { Point } from '../math/point';
import { Size } from '../math/size';
import { Matrix } from '../math/matrix';

export class ScreenDisplay {
  protected readonly glyphs: Matrix<Phaser.GameObjects.Image>
  protected readonly bg: Matrix<Phaser.GameObjects.Image>

  constructor(
    readonly font: string,
    readonly glyphSize: Size,
    readonly origin: Point,
    readonly size: Size,
    readonly make: Phaser.GameObjects.GameObjectCreator) {
    this.bg = new Matrix(size, (x, y) => this.createGlyph(x, y, 219))
    this.glyphs = new Matrix(size, (x, y) => this.createGlyph(x, y, 32))
  }

  draw(screen: ConsoleScreen): void {
    screen.forEach((sc, x, y) => this.drawChar(sc, x, y))
  }

  protected createGlyph(x: number, y: number, frame: number): Phaser.GameObjects.Image {
    const [x0, y0] = this.convert(x, y)
    const config = {
      key: this.font,
      x: x0 - this.glyphSize.width / 2,
      y: y0 - this.glyphSize.height / 2,
      frame: frame
    }
    return this.make.image(config)
  }

  protected drawChar(sc: ScreenChar, x: number, y: number) {
    const [x0, y0] = this.convert(x, y)

    // this.graphics.fillStyle(sc.bg)
    // this.graphics.fillRect(x0 - this.glyphSize.width/2, y0 - this.glyphSize.height/2, this.glyphSize.width, this.glyphSize.height)
    const bg = this.bg.get(x, y)
    if (sc.bg === 0) {
      bg.alpha = 0
    } else {
      bg.alpha = 1
      bg.tint = sc.bg

      bg.tintFill = true
    }

    const glyph = this.glyphs.get(x, y)
    glyph.setFrame(sc.c)
    if (sc.c === 0) {
      glyph.alpha = 0
    } else {
      glyph.alpha = 1
      glyph.tint = sc.fg
    }
  }

  protected convert(x: number, y: number): [number, number] {
    return [this.origin.x + x * this.glyphSize.width, this.origin.y + y * this.glyphSize.height]
  }
}